import { createSelector } from 'reselect';

export const DEFAULT_LONGTITUDE = -2.8695258;
export const DEFAULT_LATITUDE = 54.0705897;
export const DEFAULT_ZOOM = 11;
export const NO_DEPOT_ZOOM = 5;
export const INNER_ZOOM = 13;

export const getMapState = (state) => state.map;

export const getStopPopup = createSelector(
  getMapState,
  ({ stopMarkerPopup }) => stopMarkerPopup
);

export const getZoomLevel = createSelector(
  getMapState,
  ({ zoomLevel }) => zoomLevel
);

export const getMapBounds = createSelector(getMapState, ({ bounds }) => bounds);

export const isOuterZoom = createSelector(
  getZoomLevel,
  (zoomLevel) => zoomLevel < INNER_ZOOM
);
